<template>
  <div class="left_menu">
    <div id="product_category">
      <div class="menu_title">CATEGORY</div>
      <div class="menu_area">
        <ul class="ul_menu">
          <li class="ul_item" v-for="(category,index) in categoryList" :key="'menu_category-' + index" @click="routeCategory('DcCategory', category.params)">{{category.title}}</li>
        </ul>
      </div>
    </div>
    <div id="product_guide">
      <div class="menu_title">GUIDE</div>
      <div class="menu_area">
        <ul class="ul_menu">
          <!--
          <li class="ul_item" @click="routeCategory('')">会員登録・ログイン</li>
          -->
          <li class="ul_item" @click="routeCategory('DcPaymentGuide')">ご利用ガイド</li>
          <li class="ul_item" @click="routeCategory('DcRouteConfirm')">搬入経路のご確認</li>
          <li class="ul_item" @click="routeCategory('DcGuideOrder')">送料・納期・配送</li>
          <li class="ul_item" @click="routeCategory('DcGuidePayment')">お支払い方法</li>
          <li class="ul_item" @click="routeCategory('DcCorpInformation')">会社概要</li>
          <li class="ul_item" @click="routeCategory('SupportInput')">お問い合わせ</li>
        </ul>
      </div>
    </div>
    <div id="company">
      <div class="company_area">
        <ul class="ul_sub_menu">
          <li @click="route('UseRule')" class="sub_item">利用規約</li>
          <li @click="route('DcTokutei')" class="sub_item">特定商取引法の表示</li>
          <li @click="route('DcPrivacyPolicy')" class="sub_item">プライバシーポリシー</li>
        </ul>
      </div>
    </div>
    <div @click="close()">
      <div class="cross_btn">
        <span class="css-cancel"></span>
      </div>
    </div>
  </div>
</template>
<script>
import * as App from '../../../utils/App'
import {DC_STORAGE_KEY} from '../../../constants/App'

export default {
  name: 'DcHeaderMenu',
  props: {
  },
  data () {
    return {
      categoryList: [
        {id: 1, title: '吊戸棚', params: {cid: 1}},
        {id: 2, title: '食器棚', params: {cid: 2}},
        {id: 3, title: '玄関収納', params: {cid: 3}},
        // {id: 4, title: 'カウンター', params: {cid: 4}},
        {id: 5, title: '棚板', params: {cid: 5}},
        {id: 6, title: 'カウンター下収納', params: {cid: 6}},
        {id: 7, title: 'サイドボード', params: {cid: 7}},
        {id: 8, title: 'テレビボード', params: {cid: 8}},
        {id: 9, title: '本棚', params: {cid: 9}},
        {id: 14, title: 'クローゼット収納', params: {cid: 14}},
        {id: 15, title: '隙間収納', params: {cid: 15}},
        // {id: 16, title: '可動間仕切収納', params: {cid: 16}},
        // {id: 17, title: '洗面台', params: {cid: 17}},
        {id: 18, title: 'シェルフ', params: {cid: 18}}
      ],
      user: {}
    }
  },
  computed: {
    isLogin: function () {
      if (!this.user || Object.keys(this.user).length <= 0) return false
      if (this.user.userId === undefined) return false
      if (this.user.userLevel === 4) return false
      return true
    }
  },
  methods: {
    route: function (name, params) {
      this.$router.push({
        name: name,
        query: params
      })
    },
    routeCategory: function (name, params) {
      App.removeLocalStorage(DC_STORAGE_KEY.PRODUCT_SEARCH)
      this.$router.push({
        name: name,
        query: params
      })
    },
    close: function () {
      this.$emit('close')
    }
  },
  mounted () {
    this.user = App.getLocalStorage(DC_STORAGE_KEY.USER_INFO)
  }
}
</script>
<style src="../../css/dcmenu.scss" lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/main/js/hakotan/components/top/DcLeftMenu.vue